<app-toast></app-toast>

<ng-container>
  <div class="app-layout" *ngIf="isLoggedIn; else authFlow">
    <router-outlet></router-outlet>
  </div>
</ng-container>

<ng-template #authFlow>
  <router-outlet></router-outlet>
</ng-template>